import React from 'react';
import { Input } from '@heroui/react';
import { SearchDropdown } from '@/components/table';

interface SearchFieldsProps {
  searchFields: {
    message: string;
    ip: string;
  };
  setSearchFields: React.Dispatch<
    React.SetStateAction<{
      message: string;
      ip: string;
    }>
  >;
  isSearchOpen: boolean;
  setIsSearchOpen: (open: boolean) => void;
  onApply: () => void;
  onClear: () => void;
}

export function SearchFieldsComponent({
  searchFields,
  setSearchFields,
  isSearchOpen,
  setIsSearchOpen,
  onApply,
  onClear
}: SearchFieldsProps) {
  return (
    <SearchDropdown isOpen={isSearchOpen} setIsOpen={setIsSearchOpen} widthPx={200} onApply={onApply} onClear={onClear}>
      <Input
        label="Message"
        size="sm"
        value={searchFields.message}
        onValueChange={(v) => setSearchFields((s) => ({ ...s, message: v }))}
      />
      <Input
        label="IP Address"
        size="sm"
        value={searchFields.ip}
        onValueChange={(v) => setSearchFields((s) => ({ ...s, ip: v }))}
      />
    </SearchDropdown>
  );
}
